export default "__VITE_ASSET__a330cedf__"